/*
  shipping-dates.js - motorul comun pentru datele de livrare.
  Folosit de snippets/free-shipping-notice.liquid si snippets/shipping-announcement.liquid.

  - fusul orar e fortat pe Europe/Bucharest (nu conteaza setarea dispozitivului)
  - momentul exact vine din antetul Date al unui HEAD catre /cart.js (ora serverului Shopify)
  - rezultatul sincronizarii sta in sessionStorage: o singura cerere pe sesiune

  API:
    shippingDates.state(options) -> {
      delivery,          // obiect Date (data civila, ancorata la 12:00 UTC)
      dateText,          // "Luni, 28 septembrie"
      daysAway,          // cate zile calendaristice pana la livrare
      dispatch,          // ziua in care pleaca coletul\n      openToday,         // se mai poate expedia azi?
      remainingSeconds   // secunde pana la ora limita (0 daca openToday e false)
    }
    shippingDates.formatRemaining(secunde) -> "3h 12min"
    shippingDates.onSync(callback)  // apelat daca ceasul serverului corecteaza afisarea

  options: {
    timeZone, locale, cutoffHour, cutoffMinute, monthStyle,
    sameDayDays,   // zilele in care o comanda mai poate pleca in aceeasi zi (default luni-joi: [1,2,3,4])
    dispatchDays,  // zilele in care se preda curierului (default luni-vineri: [1,2,3,4,5])
    deliveryDays   // zilele in care curierul livreaza (default luni-vineri: [1,2,3,4,5])
  }
  Zilele pot fi si sub forma de sir: "1,2,3,4". 0 = duminica, 6 = sambata.
*/
(function () {
  if (window.shippingDates) return;

  var OFFSET_KEY = 'shipping-clock-offset';
  var clockOffset = 0;
  var clockSynced = false;
  var syncCallbacks = [];

  try {
    var stored = sessionStorage.getItem(OFFSET_KEY);
    if (stored !== null && !isNaN(parseInt(stored, 10))) {
      clockOffset = parseInt(stored, 10);
      clockSynced = true;
    }
  } catch (e) {
    // sessionStorage blocat (navigare privata) - mergem pe ceasul local
  }

  function now() {
    return new Date(Date.now() + clockOffset);
  }

  function zonedParts(instant, timeZone) {
    var dtf = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    var out = {};
    dtf.formatToParts(instant).forEach(function (part) {
      if (part.type !== 'literal') out[part.type] = part.value;
    });
    return {
      year: parseInt(out.year, 10),
      month: parseInt(out.month, 10),
      day: parseInt(out.day, 10),
      hour: parseInt(out.hour, 10) % 24,
      minute: parseInt(out.minute, 10),
      second: parseInt(out.second, 10)
    };
  }

  // "Data civila" ancorata la pranz UTC, ca schimbarea orei sa nu mute ziua.
  function civilDate(parts) {
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12, 0, 0));
  }

  function parseDays(value, fallback) {
    if (Array.isArray(value)) return value.map(Number);
    if (typeof value === 'string' && value.trim() !== '') {
      var list = value.split(',').map(function (n) { return parseInt(n, 10); }).filter(function (n) { return !isNaN(n); });
      if (list.length) return list;
    }
    return fallback;
  }

  function dayAllowed(date, days) {
    return days.indexOf(date.getUTCDay()) !== -1; // 0 = duminica ... 6 = sambata
  }

  function nextAllowedDay(date, days) {
    var next = new Date(date.getTime());
    for (var i = 0; i < 14; i++) {
      next.setUTCDate(next.getUTCDate() + 1);
      if (dayAllowed(next, days)) return next;
    }
    return next;
  }

  function minutesOfDay(parts) {
    return parts.hour * 60 + parts.minute;
  }

  function formatDate(date, locale, monthStyle) {
    var text = new Intl.DateTimeFormat(locale, {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: monthStyle === 'short' ? 'short' : 'long'
    }).format(date);
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function formatRemaining(totalSeconds) {
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    if (h > 0) return h + 'h ' + m + 'min';
    if (m > 0) return m + 'min ' + String(s).padStart(2, '0') + 's';
    return s + 's';
  }

  function state(options) {
    var o = options || {};
    var timeZone = o.timeZone || 'Europe/Bucharest';
    var locale = o.locale || 'ro-RO';
    var cutoffHour = o.cutoffHour == null || isNaN(o.cutoffHour) ? 14 : Number(o.cutoffHour);
    var cutoffMinute = o.cutoffMinute == null || isNaN(o.cutoffMinute) ? 30 : Number(o.cutoffMinute);
    var cutoffMinutes = cutoffHour * 60 + cutoffMinute;

    var sameDayDays = parseDays(o.sameDayDays, [1, 2, 3, 4]);   // luni - joi
    var dispatchDays = parseDays(o.dispatchDays, [1, 2, 3, 4]);    // luni - joi (vineri nu pleaca nimic)
    var deliveryDays = parseDays(o.deliveryDays, [1, 2, 3, 4, 5]); // luni - vineri

    var parts = zonedParts(now(), timeZone);
    var today = civilDate(parts);

    // Coletul pleaca azi doar intr-o zi cu procesare, inainte de ora limita.
    var openToday = dayAllowed(today, sameDayDays) &&
                    dayAllowed(today, dispatchDays) &&
                    minutesOfDay(parts) < cutoffMinutes;

    var dispatch = openToday ? today : nextAllowedDay(today, dispatchDays);
    var delivery = nextAllowedDay(dispatch, deliveryDays);

    return {
      parts: parts,
      dispatch: dispatch,
      delivery: delivery,
      dateText: formatDate(delivery, locale, o.monthStyle),
      daysAway: Math.round((delivery - today) / 86400000),
      openToday: openToday,
      remainingSeconds: openToday ? (cutoffMinutes - minutesOfDay(parts)) * 60 - parts.second : 0
    };
  }

  // Ora serverului: /cart.js nu e pus in cache, deci antetul Date e mereu proaspat.
  function syncClock() {
    if (clockSynced || typeof fetch !== 'function') return Promise.resolve(false);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sentAt = Date.now();

    return fetch(root + 'cart.js', { method: 'HEAD', cache: 'no-store', credentials: 'same-origin' })
      .then(function (response) {
        var header = response.headers.get('Date');
        if (!header) return false;

        var serverMs = Date.parse(header);
        if (isNaN(serverMs)) return false;

        var latency = (Date.now() - sentAt) / 2;
        var offset = serverMs + latency - Date.now();

        clockSynced = true;
        try { sessionStorage.setItem(OFFSET_KEY, String(Math.round(offset))); } catch (e) {}

        if (Math.abs(offset - clockOffset) < 60000) return false;

        clockOffset = offset;
        return true;
      })
      .catch(function () {
        return false; // fara retea: ramanem pe ceasul dispozitivului
      });
  }

  function onSync(callback) {
    if (typeof callback === 'function') syncCallbacks.push(callback);
  }

  window.shippingDates = {
    state: state,
    formatRemaining: formatRemaining,
    onSync: onSync,
    now: now
  };

  syncClock().then(function (changed) {
    if (!changed) return;
    syncCallbacks.forEach(function (cb) {
      try { cb(); } catch (e) {}
    });
  });
})();
